<template>
	<div class="home">
		<aside>
			<label>
				<h2 style="margin-bottom:18px;color:#ff0000 ">{{ langTxt('统计概览') }}</h2>
				<!-- //{{langTxt('统计概览',adminLang)}} -->
			</label>
		</aside>
		<div class="filter-container" style="margin-bottom:50px">
			<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
				<div class="filter-left">
					<el-date-picker v-model="dateTime" type="date" :placeholder="langTxt('日期搜索')" format="yyyy 年 MM 月 dd 日" value-format="timestamp" :picker-options="pickerOptions"></el-date-picker>
					<el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
						{{ langTxt('搜索') }}
					</el-button>
				</div>
			</el-col>
			<div class="filter-right">
				<!-- <el-switch @change="openFrame" active-value=2 inactive-value=1 v-model="open" active-text="悬浮框开"
          inactive-text="悬浮框关">
        </el-switch> -->
			</div>
		</div>
		<panel-group :handle-data="handleData" />
	</div>
</template>

<script>
	import PanelGroup from './PanelGroup';
	import { getTime } from '@/utils';
	export default {
		name: 'Home',
		components: {
			PanelGroup
		},
		data() {
			return {
				listQuery: {
					ctime: getTime('start')
				},
				open: false,
				dateTime: '',
				commonConfig: {},
				handleData: null,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now(); //选当前时间之前的时间
					}
				}
			};
		},

		computed: {},
		// 获取数据
		created() {
			setTimeout(() => {
				this.dateTime = getTime(); // 默认当天
				this.getList();
			}, 500);
		},

		methods: {
			// 搜索获取数据
			handleFilter() {
				this.listQuery.ctime = Math.round(this.dateTime / 1000);
				this.getList();
			},
			// 获取列表
			getList() {
				this.listLoading = true;
				this.request
					.get('/common-statistics', {
						params: this.listQuery
					})
					.then((ret) => {
						this.handleData = ret.list;
						setTimeout(() => {
							this.listLoading = false;
						}, 100);
					});
			}
		}
	};
</script>
